/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const demo: CommunityData = {
  code: "demo",
  inviteCode: "demo",
  name: "Demo",
  thumbnail: "https://media.werz.at/web/kune-thumbnail.jpg",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/demo-1`,
  socials: {
    instagramLink: "https://www.instagram.com/kunekbh/",
    soundcloudLink: "https://soundcloud.com/kunekbh",
  },
  styles: {
    global: {
      counterColor: "#232734",
      alternativeLogo: {
        src: "/assets/customizations/kune/logo.svg",
        styles: "w-[150px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      logo: {
        src: "/assets/customizations/kune/logo.svg",
        styles: "w-[180px] sm:w-[226px]",
      },
      contentBoxShadow: "",
      bgColor: "#cd6a4e",
      asideBg: "#ffffff",
      asideStyles: "",
      contentBg: "#ffffff",
      bgDesktop: "/assets/images/kune-bg.png",
      bgMobile: "/assets/images/kune-bg-mobile.png",
      mainFont: "font-['Montserrat']",
      primaryButton:
        "px-5 py-4 text-sm bg-black text-white disabled:opacity-20 !text-[12px] w-full sm:w-fit uppercase !font-normal !font-['Montserrat']",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      iconsColor: "#232734",
      separator: "border-black border-t",
      item: "font-bold text-[18px] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center font-mono",
      itemSelected: "bg-[#BEBEBE] bg-opacity-30",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-bold text-[24px] leading-[24px] pb-2",
      announcements: {
        lg: {
          title: "font-bold text-[20px] leading-[28px]",
          subtitle: "font-bold text-[13px] leading-[13px]",
        },
        sm: {
          title: "font-bold text-[20px] leading-[28px]",
          subtitle: "font-bold text-[13px] leading-[13px]",
        },
      },
      event: {
        title: "font-bold text-[13px] leading-5",
        subtitle: "font-bold text-[13px] leading-5",
      },
      shop: {
        title: "font-medium text-[20px] leading-[20px]",
        text: "font-medium text-[13px] leading-[24px]",
        customShopImage: "/assets/customizations/kune/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-bold text-[32px] leading-[32px] font-['Dance']",
      title: "font-bold text-[24px] leading-[24px] pb-2 font-['Montserrat']",
      description: "text-[13px] leading-[16px] font-['Montserrat']",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      created: "",
      emptyOrLoadingState: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-bold text-[24px] leading-[24px] pb-2 font-['Montserrat']",
      description: "text-[13px] leading-[16px] font-['Montserrat']",
      commentIconColor: "",
      likeIconColor: "",
    },
    events: {
      sectionHeader: "uppercase font-['Montserrat']",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "sm:text-[32px] sm:leading-[32px] text-[24px] leading-[24px] font-['Dance']",
      title: "font-bold text-[20px] leading-[20px] font-['Montserrat'] my-4",
      emptyOrLoadingState: "font-bold font-['Montserrat'] text-[20px] leading-[20px] my-8",
      duration: "font-medium text-[13px] leading-[13px] font-['Montserrat'] mb-4",
      address: "text-[12px] leading-[12px] font-['Montserrat'] uppercase",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-black",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6 ",
      emptyOrLoadingState: "font-bold font-['Montserrat'] text-[20px] leading-[20px] my-8",
      header:
        "sm:text-[32px] sm:leading-[32px] mt-2 font-['Dance'] text-[28px] leading-[28px] sm:mb-0 mb-5",
      sectionTitle: "font-['Montserrat'] sm:text-[24px] text-[20px] font-bold",
      sectionSubtitle: "font-mono text-[12px] uppercase leading-[12px]",
      text: "font-['Montserrat'] text-[13px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-black",
      map: {
        pin: "",
        border: "",
        pinColor: "#232734",
        strokeColor: "border-[#232734]",
      },
    },
    eventTickets: {
      container: "p-7 pb-10 sm:p-6 sm:pb-[62px] sm:w-[960px]",
      event: {
        title:
          "font-bold sm:text-[32px] sm:leading-[32px] text-[28px] leading-[28px] text-[#232734] uppercase font-['Montserrat']",
        subtitle:
          "font-medium text-[12px] leading-[12px] text-[#232734] uppercase mb-[5px] font-['Montserrat']",
      },
      ticket: {
        counterContainer: "",
        title:
          "font-bold sm:text-[20px] text-[16px] leading-[1] text-[#232734] font-['Montserrat']",
        description:
          "sm:text-[12px] text-[11px] sm:font-medium font-bold leading-4 font-['Montserrat'] uppercase",
        text: "font-medium text-[13px] leading-[20px] text-[#232734] font-['Montserrat']",
        price: "font-medium text-[16px] leading-[1] text-[#232734] font-['Montserrat']",
        quantity: "sm:text-[12px] text-[11px] leading-[1] text-[#232734] font-['Montserrat']",
      },
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-black",
    },
  },
}

export default demo
